const isEi = (legalForm: string): boolean => ['EI', 'EIRL'].includes(legalForm);

export default isEi;
